import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { VersionService } from '@core/services/version/version.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'hd-version',
  standalone: true,
  imports: [NgClass],
  templateUrl: './version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionComponent {
  protected version$$ = inject(VersionService).version$$;
  @Input() whiteText?: boolean;
}
